import firebase from 'firebase';
import dayjs from 'dayjs';


export const addHistory = async (project_id) => {
  const currentUser = authFirestore.currentUser;
  const path = myFirestore.collection('history');
  const current_date = dayjs(dayjs().utc().format('YYYY-MM-DD')).unix();


  const query = await path
    .where('project', '==', project_id)
    .where('uid', '==', currentUser.uid)
    .where('date', '==', current_date)
    .get()


  if(!query.size) {
    await path.add({
      project: project_id,
      uid: currentUser.uid,
      date: current_date,
      email: currentUser.email
    });
  }
};



// WEBPACK FOOTER //
// ./src/firestore/history.js